// Índice de documentos de la categoría: Etiqueta Blanca
import configurar_whatsapp_embedded_signup_etiqueta_blanca from './configurar-whatsapp-embedded-signup-etiqueta-blanca.js';
import configurar_integracion_tiktok_etiqueta_blanca from './configurar-integracion-tiktok-etiqueta-blanca.js';
import etiqueta_blanca_runamatic from './etiqueta-blanca-runamatic.js';

const etiquetaBlancaDocs = [
  etiqueta_blanca_runamatic,
  configurar_whatsapp_embedded_signup_etiqueta_blanca,
  configurar_integracion_tiktok_etiqueta_blanca,
];

export default etiquetaBlancaDocs;
